module.exports = __webpack_public_path__ + "src/assets/sounds/sand_end_sound.mp3";